import ArrayDiffer from '../../../shared/utilities/array_differ.service';

export function findNodeChanges(lastNodes, nodes) {
    return ArrayDiffer.findChanges(lastNodes, nodes, (node) => {
        return node.name;
    });
}

export function findLinkChanges(lastLinks, links) {
    return ArrayDiffer.findChanges(lastLinks, links, (link) => {
        return link.source.name + link.target.name;
    });
}
